module.exports = __webpack_public_path__ + "img/2470.84a9cdf2.jpg";